import Vue from "vue";
import Router from "vue-router";
import { TokenService } from "@services";
import store from "@/store";
import { tracer } from "@/diagnostics/tracer.js";

import DefaultLayout from "@views/Index";

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL || "/",
    routes: [
        {
            path: "/",
            component: DefaultLayout,
            meta: {
                public: true,
            },
            children: [
                {
                    path: "",
                    redirect: "/planners",
                },
                {
                    name: "Login",
                    path: "login",
                    component: () => import("@views/Login"),
                    props: true,
                    meta: {
                        public: true,
                    },
                },
                {
                    name: "Account Help",
                    path: "account-help",
                    component: () => import("@views/AccountHelp"),
                    meta: {
                        public: true,
                    },
                },
                {
                    name: "Reset Password",
                    path: "resetpassword",
                    component: () => import("@views/ResetPassword"),
                    meta: {
                        public: true,
                    },
                },
                {
                    name: "Confirm Email",
                    path: "confirm-email",
                    component: () => import("@views/ConfirmEmail"),
                    meta: {
                        public: true,
                    },
                },
                {
                    name: "Help",
                    path: "help",
                    component: () => import("@views/Help"),
                    meta: {
                        public: true,
                    },
                },
                {
                    name: "My Account",
                    path: "account",
                    component: () => import("@views/Account"),
                    meta: {
                        public: false,
                    },
                },
                {
                    name: "Planners",
                    path: "planners",
                    component: () => import("@views/Planners"),
                    meta: {
                        public: false,
                    },
                },
                {
                    name: "Planner",
                    path: "planner/:id?",
                    component: () => import("@views/Planner"),
                    props: true,
                    meta: {
                        public: false,
                    },
                },
                {
                    name: "Code Bank",
                    path: "codebank",
                    component: () => import("@views/CodeBank"),
                    meta: {
                        public: false,
                    },
                },
                {
                    name: "Field Mode",
                    path: "field/:id?",
                    component: () => import("@views/FieldMode"),
                    props: true,
                    meta: {
                        public: false,
                    },
                },
                {
                    name: "PageNotFound",
                    path: "*",
                    component: () => import("@views/PageNotFound"),
                    meta: {
                        public: false,
                    },
                },
            ],
        },
    ],
});

router.beforeEach((to, from, next) => {
    const isPublic = !!to.meta?.public;
    const isAuthenticated = !!TokenService.getToken();

    if (isAuthenticated && !store.state.user.userCreds) {
        store.dispatch("user/setUserCreds");
    }

    if (!isPublic && !isAuthenticated) {
        tracer.info("[VUE] Navigation | " + to?.fullPath + " | Not authenticated, redirecting to Login");
        next({
            path: "/login",
            query: { redirect: to.fullPath },
        });
        return;
    }

    if (isAuthenticated && to.path === "/login") {
        tracer.info("[VUE] Navigation | " + to?.fullPath + " | Already authenticated, redirecting to Planners");
        next("/planners");
        return;
    }

    tracer.info("[VUE] Navigation | " + to?.fullPath);
    next();
});

export default router;

export function TabRouteHelper(to, from, next, tabs) {
    if (tabs.length === 0) {
        next();
        return;
    }

    if (!tabs.some((x) => x.path === to.params?.tab)) {
        let basePath = to.path.substring(0, to.path.length - (to.params?.tab?.length ?? 0));

        basePath = `${basePath.trimRight("/")}/`;

        next({ path: `${basePath}${tabs[0].path}`, replace: true });

        return;
    }

    next();
}
